import React from "react"
import SbEditable from "storyblok-react"
import { darkBackground } from "../input-v2/partials/helpers"
import { S22Modal } from "./Modal"

export const S22ModalContent = ({ blok, onClick, visible, prevModal, nextModal, disbableNext, disbablePrev, noOfCards }) => (
  <SbEditable content={blok}>
    <S22Modal
      onClick={onClick}
      title={blok.title}
      visible={visible}
      content={blok.content}
      prevModal={prevModal}
      nextModal={nextModal}
      disbableNext={disbableNext}
      disbablePrev={disbablePrev}
      accent_color={blok.accent_color}
      noOfCards={noOfCards}
    >
    </S22Modal>
  </SbEditable>
)
